<!--  eslint-disable -->
<template>
	<div id="app">
		<keep-alive include="HealthAdvice,HospitalNotice,expers,home,AcademicLiteratureList">
			<router-view />
		</keep-alive>
		
	</div>
</template>


<script>
export default {
	data() {
		return {
		}
	},
	created(){
		this.$store.dispatch('tabSelect/getTabSelect')
	},

}
</script>
<style lang="less">
@import url('~@/assets/styles/reset.less');
@import url('~@/assets/iconfont/iconfont.css'); 
#app {
	width: 100%;
	height: 100%;

}

.scroll_view{
	width: 100%;
	height: 100%;
	overflow: auto;
}
.ellipsis{
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
}
.ellipsis_1 {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	word-break: break-al;
}
</style>
